import { actionTypes } from 'BASE/store/types'
import baseComponent from 'BASE/components/chat/chat.base.component.roomWindow'
import GroupRoomMemberRequestBuilder from 'BASE/common/chat/chat.groupRoomMemberRequestBuilder'
import room_message from 'TY/views/Chat/Chat.Message.vue'

export default {
    mixins: [baseComponent],
    components: {
        room_message,
    },
    data: function () {
        return {
            options: {
                isCustomizedScrollbar: true,
            }
        };
    },
    methods: {
        async removeGroupRoomMember(loginId) {
            let result = await this.$dialog.confirm("确认要删除用户?", { title: "删除用户" });
            if (result.state) {
                let builder = new GroupRoomMemberRequestBuilder();
                builder.addRoom(this.prop_window.room.id);
                builder.addMemberToRoom(this.prop_window.room.id, loginId);
                let errorMessage = await this.$store.dispatch(actionTypes.CHAT_REMOVE_GROUP_ROOM_MEMBER, { 
                    builder: builder,
                });
                if (errorMessage) {
                    this.$dialog.warning("删除用户失败，" + errorMessage);
                }
            }
        },
        async updateGroupRoomReadOnly(isReadOnly) {
            let _title = isReadOnly ? '全体禁言' : '解除全体禁言';
            let _confirmMsg = isReadOnly ? '确认要全体禁言吗?' : '确认要解除全体禁言吗?';
            let result = await this.$dialog.confirm(_confirmMsg, { title: _title });
            if (result.state) {
                let errorMessage = await this.$store.dispatch(actionTypes.CHAT_UPDATE_GROUP_ROOM_READONLY, { 
                    roomId: this.prop_window.room.id,
                    isReadOnly: isReadOnly
                });
                if (errorMessage) {
                    this.$dialog.warning("变更全体禁言状态失败，" + errorMessage);
                }
            }
        },
        async updateGroupRoomMemberReadOnly(loginId, isReadOnly) {
            let _title = isReadOnly ? '禁言用户' : '解除用户禁言';
            let _confirmMsg = isReadOnly ? '确认要禁言此用户吗?' : '确认要解除禁言此用户吗?';
            let result = await this.$dialog.confirm(_confirmMsg, { title: _title });
            if (result.state) {
                let builder = new GroupRoomMemberRequestBuilder();
                builder.addRoom(this.prop_window.room.id);
                builder.addMemberToRoom(this.prop_window.room.id, loginId);
                builder.updateMemberReadOnly(loginId, isReadOnly);
                let errorMessage = await this.$store.dispatch(actionTypes.CHAT_UPDATE_GROUP_ROOM_MEMBER_READONLY, { 
                    builder: builder
                });
                if (errorMessage) {
                    this.$dialog.warning("变更用户禁言状态失败，" + errorMessage);
                }
            }
        },
    },
    computed: {
        title: function () {
            var name = this.prop_window.room.name;
            return name;
        },
        disableInputBar: function () {
            return this.isReadOnly && !this.isGroupRoomAdmin
        }
    }
};
